import { DateObject } from 'react-multi-date-picker';

export class DateHelper {

    static buildDateRange(): [ DateObject, DateObject ] {
        const fromDate = new DateObject();
        fromDate.hour = 0;
        fromDate.minute = 0;
        fromDate.second = 0;
        
        const toDate = new DateObject();
        toDate.hour = 23;
        toDate.minute = 59;
        toDate.second = 59;

        return [ fromDate, toDate ];
    }

    static dateObjectToString = (dateObject: DateObject): string => {
        return this.dateObjectToDate(dateObject).toJSON();
    }

    static dateObjectToDate = (dateObject: DateObject): Date => {
        if (!dateObject) {
            return new Date();
        }

        let year: number = dateObject.year;
        let month: number = dateObject.month.number;
        let day: number = dateObject.day;

        return new Date(year, month - 1, day);
    }

    static formatIsoDate = (isoDate: string): string => {
        const [year, month, day] = isoDate.split("T")[0].split("-");
        return `${day}/${month}/${year}`;
    };
    

    static buildLastHistoryDate = (date: DateObject): string => {
        const pad2 = (n: number): string => n.toString().padStart(2, "0");

        const now = new Date();
        const hh = pad2(now.getHours());
        const mm = pad2(now.getMinutes());

        const { day, month, year } =
            date instanceof Date
            ? { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() }
            : date;

            
        const monthNum = Number(month);

        // Formato final: dd/mm/yyyy a las HH:MMhs
        return `${pad2(day)}/${pad2(monthNum)}/${year} a las ${hh}:${mm}hs`;
    };
}